import React from "react";
// import './mathsubject.css';
import PurchaseHistory from "../components/PurchaseHistory";
import ForStudentMenu from "../components/ForStudentMenu";

const StudentPurchaseHistory = () => {
       return (
              <div className="App-full-row-container">
                     <div className="left-menu-box-1" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                            <ForStudentMenu />
                     </div>
                     <div className="content-box-1">
                            <PurchaseHistory />
                     </div>
              </div>
       )
}

export default StudentPurchaseHistory;